import { render, staticRenderFns } from "./_Sub_categoria_dp.vue?vue&type=template&id=2027dc4e&scoped=true&"
import script from "./_Sub_categoria_dp.vue?vue&type=script&lang=js&"
export * from "./_Sub_categoria_dp.vue?vue&type=script&lang=js&"
import style0 from "./_Sub_categoria_dp.vue?vue&type=style&index=0&id=2027dc4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027dc4e",
  null
  
)

export default component.exports